module.exports = __webpack_public_path__ + "static/img/znzz53.bbb7cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz53.png
// module id = ob92
// module chunks = 73